import { render, staticRenderFns } from "./RatingSection.vue?vue&type=template&id=00d3e238&scoped=true"
import script from "./RatingSection.vue?vue&type=script&lang=js"
export * from "./RatingSection.vue?vue&type=script&lang=js"
import style0 from "./RatingSection.vue?vue&type=style&index=0&id=00d3e238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d3e238",
  null
  
)

export default component.exports